import React, { useState } from "react";

import { FiUsers } from "react-icons/fi";

import { useCurrentUser } from "hooks/auth";
import { Button } from "newui/components/Button";
import { CompanySearchModal } from "../CompanySearchModal/CompanySearchModal";

interface ExecutiveSwitchButtonProps {
	isCollapsed?: boolean;
}

export const ExecutiveSwitchButton: React.FC<ExecutiveSwitchButtonProps> = ({
	isCollapsed = false,
}) => {
	const { isExecutiveUser } = useCurrentUser() ?? {};
	const [isModalOpen, setIsModalOpen] = useState(false);

	if (!isExecutiveUser) {
		return null;
	}

	const handleOpen = () => {
		setIsModalOpen(true);
	};

	const handleClose = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<div className={isCollapsed ? "flex justify-center px-2 pb-2" : "px-4 pb-2"}>
				<Button
					btntype="secondary"
					onClick={handleOpen}
					className={`flex items-center gap-2 ${isCollapsed ? "w-auto" : "w-full"}`}
					data-testid="executive-switch-button"
					aria-label="Switch Company"
				>
					<FiUsers size={16} />
					{!isCollapsed && <span>Switch Company</span>}
				</Button>
			</div>

			<CompanySearchModal isOpen={isModalOpen} onClose={handleClose} />
		</>
	);
};
